module.exports = __webpack_public_path__ + "static/footerlogoc-f66ee2d94b8886489ff3245f380fbbde.png";